import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import NewsService from "../services/news";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { faFacebook, faLine } from "@fortawesome/free-brands-svg-icons";
import ActivitiesService from "../services/activities";
import ArticlesService from "../services/article";
import InfographicService from "../services/infographic";
import timeFunction from "../functions/getTime";
import InfographicViewer from "../components/infographic/InfographicViewer";

// ลิงก์ "ทั้งหมด" ท้ายหน้าของแต่ละประเภท
const ALL_LINK = {
  news: "/newsAndActivity/news",
  activities: "/newsAndActivity/activity",
  article: "/article",
  infographic: "/infographic",
};
const ALL_LABEL = {
  news: ["ข่าวสารทั้งหมด", "All News"],
  activities: ["กิจกรรมทั้งหมด", "All Activities"],
  article: ["บทความทั้งหมด", "All Articles"],
  infographic: ["อินโฟกราฟิกทั้งหมด", "All Infographics"],
};

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

export default function ContentDetail(props) {
  let { slug, lang } = useParams();
  let [contentData, setContentData] = useState([]);
  
  const query = useQuery();
  const status = query.get("status") || "published";

  useEffect(() => {
    window.scrollTo(0, 0);
    getContentData();
    // eslint-disable-next-line
  }, [slug, status]);

  //return lang function
  useEffect(() => {
    if (lang !== "th" && lang !== "en") {
      window.open(`/th`, "_self");
    }
  });

  const shareOnFacebook = () => {
    const url = window.location.href; // get the current URL
    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
      url
    )}`; // create the Facebook share URL with the current URL as a parameter
    window.open(facebookUrl, "_blank", "width=600,height=400"); // open the Facebook share dialog in a new tab
  };

  const shareOnLine = () => {
    const url = window.location.href; // get the current URL
    const lineUrl = `https://social-plugins.line.me/lineit/share?url=${encodeURIComponent(
      url
    )}`; // create the Line share URL with the current URL as a parameter
    window.open(lineUrl, "_blank"); // open the Line share dialog in a new tab
  };

  const getContentData = async () => {
    try {
      if (props.page === "news") {
        let res = await NewsService.getNewsBySlug(`${slug}`, status);

        if (res) {
          setContentData(res);
        } else {
          window.open(
            `/${lang}/newsAndActivity/news`,
            "_self"
          );
        }
      } else if (props.page === "activities") {
        let res = await ActivitiesService.getActivitiesBySlug(`${slug}`, status);

        if (res) {
          setContentData(res);
        } else {
          window.open(
            `/${lang}/newsAndActivity/activity`,
            "_self"
          );
        }
      } else if (props.page === "article") {
        let res = await ArticlesService.getArticlesBySlug(`${slug}`, status);

        if (res) {
          setContentData(res);
        } else {
          window.open(
            `/${lang}/article`,
            "_self"
          );
        }
      } else if (props.page === "infographic") {
        let res = await InfographicService.getInfographicBySlug(`${slug}`, status);

        if (res) {
          setContentData(res);
        } else {
          window.open(`/${lang}/infographic`, "_self");
        }
      }
    } catch {
      console.error();
    }
  };

  const bannerName = () => {
    if (contentData.title && props.page === "news") {
      return [
        { name: "News and Activity", href: "/newsAndActivity" },
        { name: "News", href: "/newsAndActivity/news" },
        {
          name:
            lang === "th"
              ? contentData?.title?.detail_TH
              : contentData?.title?.detail_EN,
        },
      ];
    } else if (contentData.title && props.page === "activities") {
      return [
        { name: "News and Activity", href: "/newsAndActivity" },
        { name: "Activities", href: "/newsAndActivity/activities" },
        {
          name:
            lang === "th"
              ? contentData?.title?.event_TH
              : contentData?.title?.event_EN,
        },
      ];
    } else if (contentData.title && props.page === "infographic") {
      return [
        { name: "Infographic", href: "/infographic" },
        {
          name:
            lang === "th"
              ? contentData?.title?.detail_TH
              : contentData?.title?.detail_EN,
        },
      ];
    } else if (contentData.title && props.page === "article") {
      return [
        { name: "Article", href: "/article" },
        {
          name:
            lang === "th"
              ? contentData?.title?.detail_TH
              : contentData?.title?.detail_EN,
        },
      ];
    }
    return []; // return an empty array if the condition is not met
  };

  return (
    <div className="content-detail pt-[135px] lg:pt-[0px]">
      <div className="section">
        <div className="page-container">
          <div className="mt-[92px] mb-[46px]">
            {status === "draft" && (
              <div className="bg-yellow-200 text-yellow-800 p-3 rounded mb-5 font-bold text-center">
                ⚠️ นี่คือหน้าจอ Preview (สถานะ: draft)
              </div>
            )}
            <p className="text-small font-normal text-left text-[#4a4f54]">
              <a href={`/${props.lang}`} className="cursor-pointer hover:text-black">
                หน้าหลัก
              </a>
              {bannerName() &&
                bannerName().map((item, i) => (
                  <span
                    key={i}
                    className="capitalize cursor-pointer"
                    onClick={() => {
                      if (
                        item.href &&
                        window.location.pathname !== `/${lang}${item.href}`
                      ) {
                        window.open(
                          `/${lang}${item.href}`,
                          "_self"
                        );
                      }
                    }}
                  >
                    {" "}
                    / {item.name}
                  </span>
                ))}
            </p>

            {contentData.title && props.page === "news" && (
              <div className="mt-[30px] mb-[15px]">
                <h1 className="text-display text-left capitalize font-bold inline-block border-b-[2px] border-lightGray pb-[5px]">
                  {lang === "th"
                    ? contentData.title.detail_TH
                    : contentData.title.detail_EN}
                </h1>
              </div>
            )}

            {contentData.title && props.page === "activities" && (
              <div className="mt-[30px] mb-[15px]">
                <h1 className="text-display text-left capitalize font-bold inline-block border-b-[2px] border-lightGray pb-[5px]">
                  {lang === "th"
                    ? contentData.title.event_TH
                    : contentData.title.event_EN}
                </h1>
              </div>
            )}

            {contentData.title && (props.page === "article" || props.page === "infographic") && (
              <div className="mt-[30px] mb-[15px]">
                <h1 className="text-display text-left capitalize font-bold inline-block border-b-[2px] border-lightGray pb-[5px]">
                  {lang === "th"
                    ? contentData.title.detail_TH
                    : contentData.title.detail_EN}
                </h1>
              </div>
            )}

            <div className="flex justify-between items-center mt-[15px] mb-[40px]">
              <div className="flex items-center gap-[12px]">
                <FontAwesomeIcon
                  icon={faCalendar}
                  className="text-body text-darkGray"
                />
                <p className="text-meta text-darkGray">
                  {timeFunction.getTime(
                    props.page === "activities"
                      ? contentData.date?.startDate
                      : contentData.publishedAt,
                    lang
                  )}
                </p>
              </div>

              <div className="flex items-center gap-[15px]">
                <p className="text-meta text-darkGray">Share : </p>
                <div className="flex items-center gap-[10px]">
                  <div
                    onClick={() => shareOnFacebook()}
                    className="w-[30px] h-[30px] bg-[#e0e0e0] rounded-full flex items-center justify-center cursor-pointer hover:bg-gray-300 transition-colors text-darkGray"
                  >
                    <FontAwesomeIcon icon={faFacebook} className="text-meta" />
                  </div>
                  <div
                    onClick={() => shareOnLine()}
                    className="w-[30px] h-[30px] bg-[#e0e0e0] rounded-full flex items-center justify-center cursor-pointer hover:bg-gray-300 transition-colors text-darkGray"
                  >
                    <FontAwesomeIcon icon={faLine} className="text-meta" />
                  </div>
                  <div
                    onClick={() => {
                      navigator.clipboard.writeText(window.location.href);
                    }}
                    className="w-[30px] h-[30px] bg-[#e0e0e0] rounded-full flex items-center justify-center cursor-pointer hover:bg-gray-300 transition-colors text-darkGray"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>

            {contentData.content && props.page === "news" && (
              <div
                className="content-html text-left my-[30px]"
                dangerouslySetInnerHTML={{
                  __html:
                    lang === "th"
                      ? contentData.content[0]?.body_TH
                      : contentData.content[0]?.body_EN,
                }}
              ></div>
            )}

            {contentData.body && props.page === "activities" && (
              <div
                className="content-html text-left my-[30px]"
                dangerouslySetInnerHTML={{
                  __html:
                    lang === "th"
                      ? contentData.body[0]?.body_TH
                      : contentData.body[0]?.body_EN,
                }}
              ></div>
            )}

            {props.page === "infographic" && contentData.images && (
              <div className="my-[30px]">
                <InfographicViewer
                  images={contentData.images}
                  title={lang === "th" ? contentData.title?.detail_TH : contentData.title?.detail_EN}
                  lang={lang}
                />
                {(lang === "th"
                  ? contentData.description?.detail_TH
                  : contentData.description?.detail_EN) && (
                  <p className="max-w-[760px] mx-auto mt-[24px] text-body text-darkGray text-left whitespace-pre-line">
                    {lang === "th"
                      ? contentData.description.detail_TH
                      : contentData.description.detail_EN}
                  </p>
                )}
              </div>
            )}

            {contentData.content && props.page === "article" && (
              <div
                className="content-html text-left my-[30px]"
                dangerouslySetInnerHTML={{
                  __html:
                    lang === "th"
                      ? contentData.content[0]?.body_TH
                      : contentData.content[0]?.body_EN,
                }}
              ></div>
            )}

            <div className="flex justify-between items-center whitespace-nowrap mt-[50px]">
              <div className="w-full border-b-[2px] border-darkGray mr-[20px]"></div>
              
              <div className="flex items-center gap-[10px] cursor-pointer hover:text-brand transition-colors"
                onClick={() =>
                  window.open(`/${lang}${ALL_LINK[props.page] || "/newsAndActivity/news"}`, "_self")
                }
              >
                <div className="flex -space-x-1">
                  <FontAwesomeIcon icon={faChevronRight} className="text-meta" />
                  <FontAwesomeIcon icon={faChevronRight} className="text-meta" />
                </div>
                <p className="text-meta font-bold">
                  <span>{(ALL_LABEL[props.page] || ALL_LABEL.news)[lang === "th" ? 0 : 1]}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
